/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { Button, Text } from 'sarsaparilla';
import AvailabilityCell from './AvailabilityCell';

import { Row, GridCell } from './Grid';

export default class AvailabilityRow extends React.PureComponent {
    static propTypes = {
        hasAreaData: PropTypes.bool,
        divisionData: PropTypes.shape({
            permit: PropTypes.object,
            division: PropTypes.object,
        }),
        availabilityCellData: PropTypes.objectOf(PropTypes.array),
        handleClick: PropTypes.func.isRequired,
        onDivisionDetailsClick: PropTypes.func,
        isSmallerGrid: PropTypes.bool,
    };

    render() {
        const {
            hasAreaData,
            divisionData,
            availabilityCellData,
            handleClick,
            onDivisionDetailsClick,
            isSmallerGrid,
        } = this.props;

        const { division } = divisionData;
        const { name, district, id: divisionId } = division;

        let divisionName = <Text>{name}</Text>;
        if (onDivisionDetailsClick) {
            divisionName = (
                <Text>
                    <Button
                        appearance="link"
                        onClick={() => onDivisionDetailsClick(divisionId)}
                    >
                        {name}
                    </Button>
                </Text>
            );
        }

        let divisionComponent = divisionName;
        if (isSmallerGrid && hasAreaData) {
            divisionComponent = (
                <>
                    {divisionName}
                    <Text>{district}</Text>
                </>
            );
        }

        return (
            <Row>
                <GridCell>
                    <div translate="no">{divisionComponent}</div>
                </GridCell>
                {hasAreaData && !isSmallerGrid && (
                    <GridCell>
                        <div translate="no">{district}</div>
                    </GridCell>
                )}
                {availabilityCellData[divisionId].map((cellData) => (
                    <AvailabilityCell
                        key={cellData.key}
                        content={cellData.content}
                        className={cellData.className}
                        tooltips={cellData.tooltips}
                        isBypassQuotaCheck={cellData.isBypassQuotaCheck}
                        isSelected={cellData.isSelected}
                        onSelectToggle={() =>
                            handleClick(
                                cellData.permitId,
                                cellData.divisionId,
                                cellData.dateKey
                            )
                        }
                        screenReaderText={`${name} on ${gnoment(cellData.dateKey).format('MMMM D, YYYY')}`}
                        status={cellData.status}
                    />
                ))}
            </Row>
        );
    }
}
